import { mapGetters } from 'vuex';

export default {
    name: 'agentNav',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dap', ['dap']),
        geoData(){
            const geo = this.glb.geo;
            return [{
                    url: `${this.glb.appUrl}agents/`,
                    name: 'Agent Directory'
                },
                ...(geo.statePath ? [{
                    url: `${this.glb.appUrl}sitemap/agents/${geo.stateCode}/`,
                    name: geo.stateFullName
                }] : []),

                ...(geo.cityPath ? [{
                    url: `${this.glb.appUrl}agents/${geo.cityCode}-${geo.stateCode}/`,
                    name: geo.city
                }] : []),
                ...(this.dap.fullName ? [{
                    url: `${this.glb.appUrl}${this.dap.profileUrl}`,
                    name: this.dap.fullName,
                    disable: true
                }] : [])
            ];
        },
        breadCrumbSchema() {
            let schemaObj = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: this.geoData.map((element, index) => {
                    return {
                        '@type': 'ListItem',
                        position: (index + 1),
                        item: {
                            '@id': element.url,
                            name: element.name
                        }
                    };
                })
            };
            return JSON.stringify(schemaObj);
        },
        isAgent(){
            return ['AGENT', 'COBROKER_AGENT'].indexOf(this.glb.user && this.glb.user.role) >= 0;
        },
        isMovotoAgent(){
            return this.dap.agentType === 1;
        }
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: `Ask ${this.dap.firstName} a Question`,
                    hotleadSub: `You can request a call, a home tour, or real estate help from ${this.dap.firstName}`,
                    hotleadType: this.glb.isMobile ? 'InlineHotleadInAgentProfilePage_sellerMOBILE' : 'InlineHotleadInAgentProfilePage_seller',
                    buttonText: 'Ask a Question',
                    showZipcode: true,
                    agentData: this.dap,
                    requestAgentId: this.dap.agentId,
                },
            });
        },

        openSendEmail() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtSendEmail',
                trigger: this.$options.name,
                opt: {
                    dialogTitle: this.molang('dpp.mvtEmail.sharemyprofile'),
                    agentData: this.dap
                }
            });
        },
        openReview(){
            this.$eventBus.$emit('eventbus-agent-openreview');
        }
    }
};